import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入语言包
import translationEN from './en.json';
import translationZH_HK from './zh-HK.json';
import translationZH_CN from './zh-CN.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: localStorage.getItem('jwt_language') || 'zh-HK',
        debug: false,
        resources: {
            en: { translation: translationEN },
            'zh-HK': { translation: translationZH_HK },
            'zh-CN': { translation: translationZH_CN },
        },
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        // detection: {
        //     order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
        //     caches: ['localStorage'],
        // },
        // react: {
        //     useSuspense: true,
        // },
    });

export default i18n;
